export const OPENAI_CONFIG = {
  apiKey: import.meta.env.VITE_OPENAI_API_KEY || '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',
  model: 'gpt-3.5-turbo',
  temperature: 0.1,
  maxRetries: 3,
  timeout: 30000,
  debug: true
};